import {emotionStyled, reducedMotionAtom} from '@packages/utilities/styled';

export const BackdropView = emotionStyled('div')(
  {
    display: 'flex',
    alignItems: 'flex-start',
    bottom: 0,
    inset: 0,
    left: 0,
    opacity: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    willChange: 'opacity',
    // This prevents the cursor from flashing to pointer when a user drags faster than the animation frames can catch up.
    '&:has(.react-draggable-dragging)': {
      cursor: 'grabbing',
    },
  },
  {
    variants: {
      shouldShowBackdrop: {
        true: {
          '&&': {
            background: '$uiModalBackdrop',
          },
        },
      },
      scrollBehavior: {
        outside: {
          overflowY: 'auto',
        },
        inside: {},
      },
    },
    composes: [reducedMotionAtom],
  }
);
